import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CookieBanner from "./CookieBanner";
import BasicSettingsLoader from "./component/BasicSettingsLoader";
import App from "./App";
import { CurrencyProvider } from "./component/CurrencyContext";
import LocationCurrencyDetector from "./component/LocationCurrencyDetector";

export default function MainApp() {
  return (
    <CurrencyProvider>
      <LocationCurrencyDetector />
      <Router>
        <ToastContainer autoClose={5000} />
        <CookieBanner />
        <BasicSettingsLoader />
        <App />
      </Router>
    </CurrencyProvider>
  );
}
